import { render, staticRenderFns } from "./ViewAlertManagement.html?vue&type=template&id=e971a74e&scoped=true&external"
import script from "./ViewAlertManagement.js?vue&type=script&lang=js&external"
export * from "./ViewAlertManagement.js?vue&type=script&lang=js&external"
import style0 from "./ViewAlertManagement.scss?vue&type=style&index=0&id=e971a74e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e971a74e",
  null
  
)

export default component.exports